import { styled } from '@styles/stitches';

export const SmallTitle = styled('div', {
  position: 'fixed',
  left: 0,
  bottom: 0,
  width: '100vw',
  height: '$space$1',
  // zIndex: -1,
  opacity: 1,
  transition: 'opacity 0.2s ease-in-out',
  display: 'none',

  '@bp1': {
    padding: '0 $space$2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },

  '@bp2': {
    padding: '0 $space$1',
  },

  variants: {
    faded: {
      true: {
        opacity: 0,
        pointerEvents: 'none',
      },
    },
  },
});
